export const buildOrQuery = (termsToMatch) => {
  let baseQuery = {
    'bool': {
      'must': [{
        'bool': {
          'should': [
            termsToMatch
          ]
        }
      }]
    }
  }
  return baseQuery
}

export const buildMustQuery = () => {
  let filteredOrQuery = {
    'bool': {
      'must': [],
      'must_not': [],
      'should': []
    }
  }
  return filteredOrQuery
}

export const buildSingleFieldQuery = (terms, fieldName) => {
  let queryString = {
    'query_string': {
      'query': 'TBA',
      'default_field': fieldName
    }
  }
  // Add wildcard to end of query
  queryString.query_string.query = (terms.split(',').join(' ') + '*')
  let query = buildMustQuery()
  query.bool.must.push(queryString)
  return queryString
}

export const buildMultiFieldQuery = (terms, fieldNames) => {
  let queryString = {
    'query_string': {
      'query': 'TBA',
      'fields': fieldNames
    }
  }
  // Add wildcard to end of query
  queryString.query_string.query = (terms.split(',').join(' ') + '*')
  let query = buildMustQuery()
  query.bool.must.push(queryString)
  return queryString
}

export const buildTitleSearchQuery = (terms) => {
  let queryString = {
    'query_string': {
      'query': 'TBA',
      'fields': [
        'title'
      ],
      'use_dis_max': false,
      'default_field': 'title'
    }
  }
  // Add wildcard to end of query
  queryString.query_string.query = (terms.split(',').join(' ') + '*')
  let query = buildMustQuery()
  query.bool.must.push(queryString)
  return queryString
}

export const buildNameSearchQuery = (terms) => {
  let fields = ['name', 'description', 'jobTitles']
  let queryString = buildMultiFieldQuery(terms, fields)
  return queryString
}

export const buildBaseQuery = () => {
  // base query when no terms are present; Weight all attributes equally in ES 1.7 Syntax
  // the caller should populate the list constant_score.query.bool.must to further customize query.
  let query = {
    'constant_score': {
      'filter': buildMustQuery(),
      'boost': 1.0
    }
  }
  return query
}

export const getTagSearchQuery = () => {
  let baseQuery = {
    'bool': {
      'must': [],
      'must_not': [],
      'should': []
    }
  }
  // added for skipping external courses from discover results
  baseQuery.bool.must_not.push(getQueryString('EXTERNAL_', 'DeliveryContext.courseType'))
  return baseQuery
}

export const getBaseQuery = (privateLibraryList, publicLibraryList, loggedInUserUUID, excludeUuid) => {
  let baseQuery = {
    'bool': {
      'must': [{
        'bool': {
          'should': [
            getLibraryFilter(privateLibraryList, publicLibraryList, loggedInUserUUID),
            getShareFilter(loggedInUserUUID),
            getEnrolledFilterForUserRole(loggedInUserUUID)
          ]
        }
      }],
      'must_not': [{
        'terms': {
          'uuid': excludeUuid
        }
      }],
      'should': [
        getShareFilter(loggedInUserUUID),
        getEnrolledFilterForUserRole(loggedInUserUUID)
      ]
    }
  }
  // added for skipping Lynda courses from discover results
  baseQuery.bool.must_not.push(getQueryString('EXTERNAL_', 'DeliveryContext.courseType'))
  return baseQuery
}

export const getLibraryFilter = (privateLibraryList, publicLibraryList, loggedInUserUUID) => {
  return {
    'bool': {
      'should': [
        getSimpleLibraryFilter(publicLibraryList),
        {
          'bool': {
            'should': [
              getSimpleLibraryFilter(privateLibraryList),
              getOwnerIdFilter(loggedInUserUUID)
            ]
          }
        }
      ]
    }
  }
}

export const getSimpleLibraryFilter = (libraryList) => {
  return {
    'terms': {
      'owningLibraryId': libraryList
    }
  }
}

export const getOwnerIdFilter = (ownerId) => {
  return {
    'bool': {
      'should': [
        getOwnerIdQuery(ownerId),
        {
          'bool': {
            'must': {
              'exists': {
                'field': 'usersHavePreviewPermission'
              }
            }
          }
        }
      ]
    }
  }
}

export const getOwnerIdQuery = (ownerId) => {
  return {
    'match': {
      'ownerId': ownerId
    }
  }
}

export const getInstitutionIdFilter = (libraryList) => {
  return {
    'terms': {
      'institutionId': libraryList
    }
  }
}

export const getShareFilter = (uuid) => {
  return getEnrolledMiscFilter('usersHavePreviewPermission', uuid)
}

export const getEnrolledMiscFilter = (fieldName, uuid) => {
  var obj = { 'match': {} }
  obj.match[fieldName] = uuid
  return obj
}

export const getEnrolledFilterForUserRole = (uuid) => {
  return getEnrolledMiscFilter(getFieldValueForRole(localStorage.getItem('userrole')), uuid)
}

export const getFieldValueForRole = (role) => {
  return (role === 'Instructor & Admin') ? 'instructors' : role.toLowerCase() + 's'
}

export const getQueryString = (queryText, defaultField, defaultOperator) => {
  let queryString = {
    'query_string': {
      'query': queryText,
      'default_field': defaultField
    }
  }
  if (defaultOperator) {
    queryString.query_string.default_operator = defaultOperator
  }
  return queryString
}

export const addAdvancedSearchQueryStrings = (state, buildQuery) => {
  // const defaultFieldPrefix = 'DeliveryContext'

  if (state.termCode) {
    buildQuery.bool.must.push(getQueryString(state.termCode, 'termCode.keyword'))
  }
  if (state.academicYear) {
    buildQuery.bool.must.push(getQueryString(state.academicYear, 'academicYear', 'AND'))
  }
  if (state.department) {
    let dept = state.department
    if (dept.indexOf(' ') !== -1) {
      dept = '"' + dept + '"'
    }
    buildQuery.bool.must.push(getQueryString(dept, 'departmentCode.keyword'))
  }
  if (state.subject) {
    let subj = state.subject
    if (subj.indexOf(' ') !== -1) {
      subj = '"' + subj + '"'
    }
    buildQuery.bool.must.push(getQueryString(subj, 'subjectCode.keyword'))
  }
  if (state.division) {
    let div = state.division
    if (div.indexOf(' ') !== -1) {
      div = '"' + div + '"'
    }
    buildQuery.bool.must.push(getQueryString(div, 'divisionCode.keyword'))
  }
  if (state.major) {
    let maj = state.major
    if (maj.indexOf(' ') !== -1) {
      maj = '"' + maj + '"'
    }
    buildQuery.bool.must.push(getQueryString(maj, 'courseMajorCodes.keyword'))
  }
  if (state.unit) {
    buildQuery.bool.must.push(getQueryString(state.unit, 'creditHour.keyword'))
  }
  if (state.monday) {
    buildQuery.bool.must.push(getQueryString('monday', 'meetingDaysFormatted.day.keyword'))
  }
  if (state.tuesday) {
    buildQuery.bool.must.push(getQueryString('tuesday', 'meetingDaysFormatted.day.keyword'))
  }
  if (state.wednesday) {
    buildQuery.bool.must.push(getQueryString('wednesday', 'meetingDaysFormatted.day.keyword'))
  }
  if (state.thursday) {
    buildQuery.bool.must.push(getQueryString('thursday', 'meetingDaysFormatted.day.keyword'))
  }
  if (state.friday) {
    buildQuery.bool.must.push(getQueryString('friday', 'meetingDaysFormatted.day.keyword'))
  }

  // CSW
  if (state.block) {
    buildQuery.bool.must.push(getQueryString('"' + state.block + '"', 'block'))
  }
  if (state.level) {
    buildQuery.bool.must.push(getQueryString(state.level, 'gradeLevel'))
  }

  if (state.instructor) {
    let queryString = {
      'term': {
        'instructorNames': state.instructor
      }
    }
    buildQuery.bool.must.push(queryString)
  }

  if (state.selectedCourseFlags && state.selectedCourseFlags.length) {
    let queryString = {
      'terms': {
        'courseFlags.keyword': state.selectedCourseFlags.slice()
      }
    }
    buildQuery.bool.must.push(queryString)
  }

  addMeetingTimes(state, buildQuery)

  return buildQuery
}

export const addCatalogSearchCriteria = (state, buildQuery) => {
  let indexName = 'catalog'
  if (state.department) {
    buildQuery.bool.must.push(buildIndexQueryClause(indexName, 'department', state.department))
  }
  if (state.subject) {
    buildQuery.bool.must.push(buildIndexQueryClause(indexName, 'subject', state.subject))
  }
  if (state.division) {
    buildQuery.bool.must.push(buildIndexQueryClause(indexName, 'division', state.division))
  }

  return buildQuery
}

export const buildMeetingTimeClauses = (classTimeFrom, classTimeTo) => {
  let meetingClauses = []

  let fromTimeClause
  let toTimeClause
  if (classTimeFrom && classTimeTo) {
    toTimeClause = {
      'meetingDaysFormatted.meetingToTimeFormatted': {
        'gte': classTimeFrom,
        'lte': classTimeTo
      }
    }
    meetingClauses.push(buildMeetingTimeClause(toTimeClause))
  } else if (classTimeFrom && !classTimeTo) {
    fromTimeClause = {
      'meetingDaysFormatted.meetingFromTimeFormatted': {
        'gte': classTimeFrom
      }
    }
    toTimeClause = {
      'meetingDaysFormatted.meetingToTimeFormatted': {
        'gte': classTimeFrom
      }
    }
    meetingClauses.push(buildMeetingTimeClause(fromTimeClause))
    meetingClauses.push(buildMeetingTimeClause(toTimeClause))
  } else if (!classTimeFrom && classTimeTo) {
    toTimeClause = {
      'meetingDaysFormatted.meetingToTimeFormatted': {
        'lte': classTimeTo
      }
    }
    meetingClauses.push(buildMeetingTimeClause(toTimeClause))
  }
  return meetingClauses
}

export const buildMeetingTimeClause = (rangeClause) => {
  let meetingTime = {
    'range': rangeClause
  }
  return meetingTime
}

export const buildMeetingBlockClause = (rangeClause) => {
  let meetingTime = {
    'indices': {
      'index': 'deliverycontext',
      'query': {
        'range': rangeClause
      }
    }
  }
  return meetingTime
}

export const buildIndexQueryClause = (indexName, termKey, termValue) => {
  let indexClause = {
    'indices': {
      'index': indexName,
      'query': {
        'term': {}
      }
    }
  }
  indexClause.indices.query.term[termKey] = termValue
  return indexClause
}

export const addMeetingTimes = (state, buildQuery) => {
  // CSW needs to uses blocks instead of meeting times
  if (!state.courseSearchFlags || !state.courseSearchFlags.showTimeCriteria || !state.courseSearchFlags.showTimeCriteria.enabled) {
    return
  }

  let meetingClauses = buildMeetingTimeClauses(state.classTimeFrom, state.classTimeTo)
  if (meetingClauses.length > 0) {
    meetingClauses.forEach(function (meetingClause) {
      buildQuery.bool.must.push(meetingClause)
    })
  }
  return buildQuery
}

export const originUuidCheck = () => {
  let originUuidCheck = {
    'must_not': {
      'exists': {
        'field': 'originUuid'
      }
    }
  }
  return originUuidCheck
}

export const shouldUpdateFacet = (facetName, resetAllFacets, selectedFacetNames) => {
  return resetAllFacets || !selectedFacetNames || !selectedFacetNames.includes(facetName)
}

export const getUpdatedFacet = (facetName, inputState) => {
  const resetAllFacets = inputState.resetAllFacets
  const selectedFacetNames = inputState.selectedFacetNames
  const responseFacets = inputState.responseFacets
  const currentFacets = inputState.currentFacets

  let currentFacet = currentFacets[facetName] || []
  let responseFacet = responseFacets[facetName] || []
  let useResponseFacets = shouldUpdateFacet(facetName, resetAllFacets, selectedFacetNames)
  return useResponseFacets ? responseFacet : currentFacet
}



// WEBPACK FOOTER //
// ./src/app/search/searchUtils.js